module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Cabo-Roche-9ecfaa4b544494caa30c82f6100cf3cd.jpg";